(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('[data-button]'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.announcementBarHeight = !!document.getElementById('shopify-section-announcement-bar') ? document.getElementById('shopify-section-announcement-bar').getBoundingClientRect().height : 0 ;
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.announcementBarHeight) {
        
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-list"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Remove 'no-js-hidden' class from all elements
    document.querySelectorAll('.no-js-hidden').forEach(function(element) {
      element.classList.remove('no-js-hidden');
    });
  
    const productRows = document.querySelectorAll('.product-row');
  
    productRows.forEach(function(productRow) {
      const packageSize = parseInt(productRow.getAttribute('data-package-size')) || 0;
      const totalAvailableQuantity = parseInt(productRow.getAttribute('data-total-available-quantity')) || 0;
  
      const variantRows = productRow.querySelectorAll('.variant-row');
      const variantCount = variantRows.length;
  
      // Collect quantity inputs
      const quantityInputs = productRow.querySelectorAll('.quantity__input');
  
      if (packageSize === 0 || totalAvailableQuantity < packageSize) {
        // No package size validation needed, the user can order any amount up to available quantity
        quantityInputs.forEach(function(quantityInput) {
          const minusButton = quantityInput.closest('.quantity').querySelector('button[name="minus"]');
          const plusButton = quantityInput.closest('.quantity').querySelector('button[name="plus"]');
  
          const maxQuantity = parseInt(quantityInput.getAttribute('data-max-quantity')) || Infinity;
  
          if (quantityInput && minusButton && plusButton) {
            // Plus button event
            plusButton.addEventListener('click', function(event) {
              event.preventDefault();
              let currentValue = parseInt(quantityInput.value) || 0;
              if (currentValue < maxQuantity) {
                currentValue += 1;
                quantityInput.value = currentValue;
              }
            });
  
            // Minus button event
            minusButton.addEventListener('click', function(event) {
              event.preventDefault();
              let currentValue = parseInt(quantityInput.value) || 0;
              if (currentValue > 0) {
                currentValue -= 1;
                quantityInput.value = currentValue;
              }
            });
          }
        });
      } else {
        // Package size is greater than zero and total available quantity is sufficient, apply validation
        if (variantCount === 1) {
          // Single Variant Product
          const quantityInput = quantityInputs[0];
          const minusButton = productRow.querySelector('button[name="minus"]');
          const plusButton = productRow.querySelector('button[name="plus"]');
  
          const maxQuantity = parseInt(quantityInput.getAttribute('data-max-quantity')) || Infinity;
  
          if (quantityInput && minusButton && plusButton) {
            // Plus button event
            plusButton.addEventListener('click', function(event) {
              event.preventDefault();
              let currentValue = parseInt(quantityInput.value) || 0;
              if (currentValue + packageSize <= maxQuantity) {
                currentValue += packageSize;
                quantityInput.value = currentValue;
              }
            });
  
            // Minus button event
            minusButton.addEventListener('click', function(event) {
              event.preventDefault();
              let currentValue = parseInt(quantityInput.value) || 0;
              currentValue = Math.max(0, currentValue - packageSize);
              quantityInput.value = currentValue;
            });
  
            // On manual input
            quantityInput.addEventListener('change', function() {
              let inputValue = parseInt(quantityInput.value) || 0;
              let adjustedValue = Math.min(inputValue, maxQuantity);
              adjustedValue = Math.round(adjustedValue / packageSize) * packageSize;
              quantityInput.value = adjustedValue;
            });
          }
        } else {
          // Multiple Variant Product
          const validateTotalQuantity = function() {
            let totalQuantity = 0;
            quantityInputs.forEach(function(input) {
              totalQuantity += parseInt(input.value) || 0;
            });
  
            if (totalQuantity % packageSize !== 0) {
              const remainder = packageSize - (totalQuantity % packageSize);
              const message = 'Please add ' + remainder + ' more item(s) to reach a multiple of ' + packageSize + '.';
              // Display message
              let messageElement = productRow.querySelector('.package-size-message');
              if (!messageElement) {
                messageElement = document.createElement('div');
                messageElement.classList.add('package-size-message');
                messageElement.style.color = 'red';
                messageElement.style.marginTop = '10px';
                productRow.appendChild(messageElement);
              }
              messageElement.textContent = message;
            } else {
              // Remove message if total quantity is valid
              const messageElement = productRow.querySelector('.package-size-message');
              if (messageElement) {
                messageElement.remove();
              }
            }
          };
  
          // Add event listeners to quantity inputs
          quantityInputs.forEach(function(quantityInput) {
            const variantId = quantityInput.dataset.variantId;
            const minusButton = productRow.querySelector('button[name="minus"][data-variant-id="' + variantId + '"]');
            const plusButton = productRow.querySelector('button[name="plus"][data-variant-id="' + variantId + '"]');
  
            const maxQuantity = parseInt(quantityInput.getAttribute('data-max-quantity')) || Infinity;
  
            if (minusButton && plusButton) {
              // Plus button event
              plusButton.addEventListener('click', function(event) {
                event.preventDefault();
                let currentValue = parseInt(quantityInput.value) || 0;
                if (currentValue < maxQuantity) {
                  currentValue += 1;
                  quantityInput.value = currentValue;
                  validateTotalQuantity();
                }
              });
  
              // Minus button event
              minusButton.addEventListener('click', function(event) {
                event.preventDefault();
                let currentValue = parseInt(quantityInput.value) || 0;
                if (currentValue > 0) {
                  currentValue -= 1;
                  quantityInput.value = currentValue;
                  validateTotalQuantity();
                }
              });
            }
  
            // On manual input
            quantityInput.addEventListener('change', function() {
              let inputValue = parseInt(quantityInput.value) || 0;
              inputValue = Math.min(inputValue, maxQuantity);
              quantityInput.value = inputValue;
              validateTotalQuantity();
            });
          });
        }
      }
  
      // Prevent form submission if total quantity is zero or invalid
      const form = productRow.querySelector('form');
      if (form) {
        form.addEventListener('submit', function(event) {
          let totalQuantity = 0;
          quantityInputs.forEach(function(input) {
            totalQuantity += parseInt(input.value) || 0;
          });
  
          if (totalQuantity === 0) {
            event.preventDefault();
            alert('Please enter a quantity for at least one variant.');
          } else if (packageSize > 0 && totalAvailableQuantity >= packageSize && totalQuantity % packageSize !== 0) {
            event.preventDefault();
            alert('The total quantity must be a multiple of ' + packageSize + '. Please adjust your quantities.');
          }
        });
      }
    });
  });




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);


  //Variant code
    document.addEventListener('DOMContentLoaded', function() {
    // Remove 'no-js-hidden' class from all elements
    document.querySelectorAll('.no-js-hidden').forEach(function(element) {
      element.classList.remove('no-js-hidden');
    });
  
    // Select the product form
    const productForm = document.querySelector('.multivariant-product-form');
  
    if (productForm) {
      const packageSize = parseInt(productForm.querySelector('.product-form').getAttribute('data-package-size')) || 0;
      const totalAvailableQuantity = parseInt(productForm.querySelector('.product-form').getAttribute('data-total-available-quantity')) || 0;
  
      const quantityInputs = productForm.querySelectorAll('.quantity__input');
  
      if (packageSize === 0 || totalAvailableQuantity < packageSize) {
        // No package size validation needed, the user can order any amount up to available quantity
        quantityInputs.forEach(function(quantityInput) {
          const minusButton = quantityInput.closest('.quantity').querySelector('button[name="minus"]');
          const plusButton = quantityInput.closest('.quantity').querySelector('button[name="plus"]');
  
          const maxQuantity = parseInt(quantityInput.getAttribute('data-max-quantity')) || Infinity;
  
          if (quantityInput && minusButton && plusButton) {
            // Plus button event
            plusButton.addEventListener('click', function(event) {
              event.preventDefault();
              let currentValue = parseInt(quantityInput.value) || 0;
              if (currentValue < maxQuantity) {
                currentValue += 1;
                quantityInput.value = currentValue;
              }
            });
  
            // Minus button event
            minusButton.addEventListener('click', function(event) {
              event.preventDefault();
              let currentValue = parseInt(quantityInput.value) || 0;
              if (currentValue > 0) {
                currentValue -= 1;
                quantityInput.value = currentValue;
              }
            });
          }
        });
      } else {
        // Package size is greater than zero and total available quantity is sufficient, apply validation
  
        const validateTotalQuantity = function() {
          let totalQuantity = 0;
          quantityInputs.forEach(function(input) {
            totalQuantity += parseInt(input.value) || 0;
          });
  
          if (totalQuantity % packageSize !== 0) {
            const remainder = packageSize - (totalQuantity % packageSize);
            const message = 'Please add ' + remainder + ' more item(s) to reach a multiple of ' + packageSize + '.';
            // Display message
            let messageElement = productForm.querySelector('.package-size-message');
            if (!messageElement) {
              messageElement = document.createElement('div');
              messageElement.classList.add('package-size-message');
              messageElement.style.color = 'red';
              messageElement.style.marginTop = '10px';
              productForm.appendChild(messageElement);
            }
            messageElement.textContent = message;
          } else {
            // Remove message if total quantity is valid
            const messageElement = productForm.querySelector('.package-size-message');
            if (messageElement) {
              messageElement.remove();
            }
          }
        };
  
        // Add event listeners to quantity inputs
        quantityInputs.forEach(function(quantityInput) {
          const variantId = quantityInput.dataset.variantId;
          const minusButton = productForm.querySelector('button[name="minus"][data-variant-id="' + variantId + '"]');
          const plusButton = productForm.querySelector('button[name="plus"][data-variant-id="' + variantId + '"]');
  
          const maxQuantity = parseInt(quantityInput.getAttribute('data-max-quantity')) || Infinity;
  
          if (minusButton && plusButton) {
            // Plus button event
            plusButton.addEventListener('click', function(event) {
              event.preventDefault();
              let currentValue = parseInt(quantityInput.value) || 0;
              if (currentValue < maxQuantity) {
                currentValue += 1;
                quantityInput.value = currentValue;
                validateTotalQuantity();
              }
            });
  
            // Minus button event
            minusButton.addEventListener('click', function(event) {
              event.preventDefault();
              let currentValue = parseInt(quantityInput.value) || 0;
              if (currentValue > 0) {
                currentValue -= 1;
                quantityInput.value = currentValue;
                validateTotalQuantity();
              }
            });
          }
  
          // On manual input
          quantityInput.addEventListener('change', function() {
            let inputValue = parseInt(quantityInput.value) || 0;
            inputValue = Math.min(inputValue, maxQuantity);
            quantityInput.value = inputValue;
            validateTotalQuantity();
          });
        });
      }
  
      // Prevent form submission if total quantity is zero or invalid
      productForm.addEventListener('submit', function(event) {
        let totalQuantity = 0;
        quantityInputs.forEach(function(input) {
          totalQuantity += parseInt(input.value) || 0;
        });
  
        if (totalQuantity === 0) {
          event.preventDefault();
          alert('Please enter a quantity for at least one variant.');
        } else if (packageSize > 0 && totalAvailableQuantity >= packageSize && totalQuantity % packageSize !== 0) {
          event.preventDefault();
          alert('The total quantity must be a multiple of ' + packageSize + '. Please adjust your quantities.');
        }
      });
    }
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            // displatch event to convert money
            document.dispatchEvent(new Event('currency:convert'));
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
